/******************************************************************************************
 *	Reseller Reminder Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.resellerReminderModal', [])
    .factory(
      'ResellerReminderModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/reseller-reminder-modal.html',
          controller: 'ResellerReminderModalController',
          classNames: 'reminder-modal'
        });
      }
    )
    .controller(
      'ResellerReminderModalController',
      /* @ngInject */
      function($log, $scope, ResellerReminderModal, CurtainNotifications, ResellerInvitation) {
        //Set initial input value
        $scope.newEmail = $scope.reseller.email;

        //Control vars for UI validation errors
        $scope.submitAttempted = false; //Was submit button clicked?

        var resetSubmit = function() {
          ResellerReminderModal.unsetLoadingState();
          $scope.submitted = false;
          $scope.submitAttempted = false;
        };

        $scope.submit = function() {
          if (!$scope.submitted) {
            $scope.submitAttempted = true;

            if ($scope.reminderForm.$valid) {
              $scope.submitted = true;
              ResellerReminderModal.setLoadingState();

              var payload = {email: $scope.newEmail};

              ResellerInvitation.updateEmail($scope.reseller.id, payload)
                .then(function(responseData) {
                  CurtainNotifications.show(
                    CurtainNotifications.SUCCESS,
                    'sendReminderModal.notifications.submitSuccess',
                    {name: $scope.reseller.name, email: $scope.newEmail}
                  );
                  ResellerReminderModal.remove({response: responseData});
                })
                .catch(function(response) {
                  if (response.status !== 0) {
                    //status is 0 when call is aborted
                    //Get first character from HTTP status as number
                    var statusType = +('' + response.status).charAt(0);

                    if (statusType === 4) {
                      if (response.data.errorCode === 'INVALID_EMAIL') {
                        $scope.emailIsInvalid = true;
                      } else if (response.data.errorCode === 'INVITE_ALREADY_ACCEPTED') {
                        CurtainNotifications.show(
                          CurtainNotifications.NOTICE,
                          'sendReminderModal.notifications.invitationAlreadyAccepted'
                        );

                        //Close reminder modal
                        ResellerReminderModal.remove();
                      } else {
                        CurtainNotifications.show(
                          CurtainNotifications.ERROR,
                          'generic.notifications.error'
                        );
                        $log.error('Failed to update reseller invite email', response.data);
                      }

                      resetSubmit();
                    } else {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                      resetSubmit();
                      $log.error('Failed to update reseller invite email', response.data);
                    }
                  }
                });
            }
          }
        };

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          ResellerReminderModal.remove({cancelled: true});
        };
      }
    );
})();
